import React, { useCallback, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  selectSettingPicture,
  selectPreviewType,
  setPictureFile,
  deletePicture,
  beginUseCamera,
  PT_NONE,
} from "slices/createPictureSlice";
import XbuttonDelete from "graphics/icons/XbuttonDelete";
import EditPicButton from "../General-UI/EditPicButton";
import ConfirmButton from "./ConfirmButton";
import TakeNow from "graphics/icons/TakeNow";
import Upload from "graphics/icons/Upload";

const Form = () => {
  const dispatch = useDispatch();
  const previewType = useSelector(selectPreviewType);
  const settingPicture = useSelector(selectSettingPicture);

  const inputElement = useRef<HTMLInputElement>(null);
  const getFile = useCallback(() => inputElement?.current?.click(), []);

  return (
    <div className="signInUpFormBox form-shadow text-center bg-white createPicFormHeading">
      People need a professional picture to recognise you
      <br></br>
      <div className="form-picture-buttons">
        <input
          style={{ display: "none" }}
          type="file"
          onChange={(e) => {
            e.target.files && dispatch(setPictureFile(e.target.files[0]));
          }}
          ref={inputElement}
          accept="image/*"
        />
        <EditPicButton
          disabledOn={settingPicture}
          text="Upload"
          onClick={getFile}
        >
          <Upload />
        </EditPicButton>
        <EditPicButton
          disabledOn={settingPicture}
          text="Use Camera"
          onClick={() => dispatch(beginUseCamera())}
        >
          <TakeNow />
        </EditPicButton>
        <EditPicButton
          disabledOn={settingPicture || previewType === PT_NONE}
          text="Delete"
          onClick={() => dispatch(deletePicture())}
        >
          <XbuttonDelete />
        </EditPicButton>
      </div>
      <ConfirmButton />
    </div>
  );
};

export default Form;
